// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__P38dD","info":"PatientInfo_info__1zSN_"};